import L from 'leaflet';
import 'leaflet.markercluster';

export const activitiesCluster = (cluster: L.MarkerCluster) => {
  const count = cluster.getChildCount();
  if (count > 1) {
    return L.divIcon({
      html: `<div class="activity-cluster">${count}</div>`,
      iconAnchor: [15, 15],
    });
  }
};